import { useEffect, useState } from "react";

export const useFetchAllNews = () => {
    const url = `${process.env.REACT_APP_API_URL}/api/posts`;
    
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(url, {
            method:"GET",
            headers: {
                "Content-Type": "application/json",
                "x-api-key": `${process.env.REACT_API_KEY}`,
            },
            });

            if (!response.ok) {
            throw new Error("Network response was not ok");
            }
            const json = await response.json();
            setData(json.post);
            setIsLoading(false);
        } catch (error) {
            setError(error);
            setIsLoading(false);
        }
        };

        fetchData();
    }, [url]);

  return { data, isLoading, error };
}
